module.exports = __webpack_public_path__ + "/images/logo-af-amazon.af137fa.svg";